'use client';

import { useEffect } from 'react';
import type { Locale } from '@/lib/content';

interface SetLanguageProps {
  locale: Locale;
}

export function SetLanguage({ locale }: SetLanguageProps) {
  useEffect(() => {
    document.documentElement.lang = locale;
    document.documentElement.setAttribute('data-locale', locale);
  }, [locale]);

  return null;
}
